'use client';

import TrackInteractionProvider from '@blueshift-ui/telemetry/dist/components/track-interaction-provider';
import { GoogleAnalytics } from '@next/third-parties/google';
import { Suspense } from 'react';

import AppPageViewTracker from '../components/app-router/page-view-tracker';
import RootScripts from '../components/app-router/root-scripts';

interface ClientProvidersProps {
  children: React.ReactNode;
}

export default function ClientProviders({ children }: ClientProvidersProps) {
  const applicationId = 'hotmath';
  const publicNodeEnv = process.env.NEXT_PUBLIC_NODE_ENV ?? 'production';
  const disabled = publicNodeEnv === 'development';
  const trackerEnv = process.env.NEXT_PUBLIC_INTERACTION_TRACKER_ENV ?? 'production';
  const preview = trackerEnv !== 'production';

  return (
    <TrackInteractionProvider applicationId={applicationId} disabled={disabled} preview={preview}>
      <div className="App min-h-screen">{children}</div>
      <Suspense fallback={null}>
        <AppPageViewTracker />
      </Suspense>
      {process.env.NEXT_PUBLIC_GA_MEASUREMENT_ID && (
        <GoogleAnalytics gaId={process.env.NEXT_PUBLIC_GA_MEASUREMENT_ID} />
      )}
      <RootScripts />
    </TrackInteractionProvider>
  );
}


